import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, fireDB } from "./firebaseConfig";
import {
  Timestamp,
  getDocs,
  collection,
  doc,
  setDoc,
} from "firebase/firestore";
import Loader from "./Loader";

function Signup() {
  // ✅ FIX HERE (no context)
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const querySnapshot = await getDocs(
          collection(fireDB, "products")
        );

        const categories = new Set();

        querySnapshot.forEach((doc) => {
          const product = doc.data();
          if (product.category) {
            categories.add(product.category);
          }
        });

        setAvailableCategories([...categories]);
      } catch (error) {
        console.error(error);
        toast.error("Failed to load categories");
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  const toggleCategorySelection = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  const signup = async () => {
    setLoading(true);

    if (!name || !email || !password) {
      toast.error("All fields are required");
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      setLoading(false);
      return;
    }

    try {
      const users = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      const user = {
        name,
        uid: users.user.uid,
        email: users.user.email,
        selectedCategories,
        time: Timestamp.now(),
      };

      await setDoc(doc(fireDB, "users", users.user.uid), user);

      toast.success("Signup Successful");

      setName("");
      setEmail("");
      setPassword("");

      navigate("/login");
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      {loading && <Loader />}

      <div className="bg-gray-800 px-10 py-10 rounded-xl w-full max-w-md">
        <h1 className="text-center text-white text-xl mb-4 font-bold">
          Signup
        </h1>

        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="bg-gray-600 mb-4 px-2 py-2 w-full rounded-lg text-white"
          placeholder="Name"
        />

        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-gray-600 mb-4 px-2 py-2 w-full rounded-lg text-white"
          placeholder="Email"
        />

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="bg-gray-600 mb-4 px-2 py-2 w-full rounded-lg text-white"
          placeholder="Password"
        />

        {loadingCategories ? (
          <p className="text-white">Loading categories...</p>
        ) : (
          <div className="mb-4 max-h-40 overflow-y-auto">
            <h3 className="text-white mb-2">Select Categories:</h3>

            {availableCategories.map((cat) => (
              <div key={cat} className="flex items-center mb-2">
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(cat)}
                  onChange={() => toggleCategorySelection(cat)}
                  className="mr-2"
                />
                <label className="text-white">{cat}</label>
              </div>
            ))}
          </div>
        )}

        <button
          onClick={signup}
          className="bg-red-500 w-full text-white font-bold px-2 py-2 rounded-lg"
        >
          Signup
        </button>

        <h2 className="text-white mt-3">
          Have an account{" "}
          <Link className="text-red-500 font-bold" to="/login">
            Login
          </Link>
        </h2>
      </div>
    </div>
  );
}

export default Signup;